import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { publisherDetailsPath, publisherDetailsState } from "../misc/constants";
import { initialsOf } from "../misc/utils";

// Shared by the cross-brand list and a brand's Publishers tab so a publisher looks
// and opens the same way from both. The row itself is clickable too; the name stays
// a real link so cmd/ctrl-click still opens a new tab.
const PublisherCell = ({ publisher, from }) => (
    <Link
        to={publisherDetailsPath(publisher._id)}
        state={publisherDetailsState(publisher, from)}
        onClick={(e) => e.stopPropagation()}
        className="group flex min-w-0 items-center gap-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-light text-xs font-semibold text-primary">
            {initialsOf(publisher.holder_name)}
        </span>
        <span className="min-w-0">
            <span className="block truncate font-medium text-gray-900 group-hover:text-accent group-hover:underline">{publisher.holder_name || "—"}</span>
            {publisher.email && <span className="block truncate text-xs text-muted">{publisher.email}</span>}
        </span>
    </Link>
);

PublisherCell.propTypes = {
    publisher: PropTypes.object.isRequired,
    from     : PropTypes.shape({ id: PropTypes.string, label: PropTypes.string, to: PropTypes.string, tab: PropTypes.string })
};

export default PublisherCell;
